
import { canonical } from "@utils";
import { getCMSCopy } from "@/common/services/cmsCopyService";

export default {
	name: "About",
	data() {
		return {
			pageTitle: "",
			pageTeaser: "",
			pageContent: "",
			pageMetaTitle: "",
			pageMetaDescription: "",
		};
	},
	// fetch: content loading (SSR + client nav). Non-blocking on the client, so
	// navigating here no longer freezes the route transition.
	async fetch() {
		await this.loadData();
	},
	head() {
		return {
			title:
				this.pageMetaTitle ||
				"About WordFinder by YourDictionary: Who We Are and What We Do",
			meta: [
				{
					name: "description",
					content:
						this.pageMetaDescription ||
						"WordFinder by YourDictionary is the resource word game fans trust to help them win. Learn all about how we got started, our mission and our team in this overview.",
				},
			],
			link: [canonical(this.$route)],
		};
	},
	mounted() {
		try {
			const h2s = this.$el.querySelectorAll("h2");
			h2s.forEach((h2) => {
				if (h2.textContent?.toLowerCase() === "contact us") {
					h2.setAttribute("id", "contact-us");

					if (this.$route.hash === "#contact-us") {
						h2.scrollIntoView({ behavior: "smooth" });
					}
				}
			});
		} catch (error) {
			console.warn("Unable to tag Contact Us header", error);
		}
	},
	methods: {
		async loadData() {
			const cmsCopy = await getCMSCopy(
				this.$axios,
				this.$config,
				".seo.landing.about-us",
				process.env.version
			);

			this.pageTitle = cmsCopy?.data?.title || "";
			this.pageTeaser = cmsCopy?.data?.teaser || "";
			this.pageContent = cmsCopy?.data?.body || "";
			this.pageMetaTitle = cmsCopy?.data?.metaTitle || "";
			this.pageMetaDescription = cmsCopy?.data?.metaDescription || "";
		},
	},
};
